import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Supabase URL or Anon Key is not set. Please update your .env file.');
    throw new Error("Supabase credentials are not set.");
}

// Regular client for public operations
// For admin operations, we use secure RPC functions that verify JWT tokens
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Note: Admin operations should use backend API routes with SUPABASE_SERVICE_ROLE_KEY
// Never expose service keys in the frontend bundle 